<template>
  <div id="curseware-eaxm">
    <comheader></comheader>
    <comtop></comtop>

    <el-main>
      <div class="crumbs">课件考试 &nbsp;&gt;</div>
      <div id="main">
        <div class="result-class flex">
          <el-button
            :type="nowIndexButton === index ? 'primary' : ''"
            v-for="(item, index) in examButtonList"
            :key="item.id"
            @click="changeStatistics(index)"
            >{{ item.name }}({{ item.count }})</el-button
          >
        </div>
        <div class="result-select flex">
          <!--  -->
          <el-select
            popper-class="first-select"
            v-model="nowCourseware"
            filterable
            clearable
            placeholder="请输入/选择课件名称"
            @change="getReportList(true, 1)"
          >
            <el-option
              v-for="item in courseware"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="nowTestPaper"
            filterable
            clearable
            placeholder="请输入/选择试卷名称"
            @change="getReportList(true, 1)"
          >
            <el-option
              v-for="item in testPaper"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="nowPersonnel"
            filterable
            clearable
            placeholder="请输入/选择人员"
            @change="getReportList(true, 1)"
          >
            <el-option
              v-for="item in personnel"
              v-if="item.name"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="nowDepartment"
            filterable
            clearable
            placeholder="请输入/选择部门"
            @change="getReportList(true, 1)"
          >
            <el-option
              v-for="item in department"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="nowExamResult"
            filterable
            clearable
            placeholder="请输入/选择考试结果"
            @change="getReportList(true, 1)"
          >
            <el-option
              v-for="item in examResult"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
          <el-date-picker
            v-model="selectTime"
            @change="getReportList(true, 1)"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            size="small"
            value-format="yyyy-MM-dd"
          />
          <el-button type="primary" @click="getReportList(true, 1)"
            >搜索</el-button
          >
        </div>
        <div class="result-table">
          <el-table :data="tableData" stripe style="width: 100%" :border="true">
            <el-table-column
              prop="id"
              label="ID"
              width="80"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="课件名称"
              :show-overflow-tooltip="true"
              header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.e_name }}
              </template>
            </el-table-column>
            <el-table-column
              label=""
              width="60"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="previewCourseware(scope.row.aid, scope.row.wid)"
                  >预览</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              label="试卷名称"
              :show-overflow-tooltip="true"
              header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.paper_name }}
              </template>
            </el-table-column>
            <el-table-column
              label=""
              width="60"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="previewPaper(scope.row.paper_id)"
                  >预览</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="nickname"
              label="人员"
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="depart"
              label="所属部门"
              :show-overflow-tooltip="true"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="考试结果"
              width="120"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.states === "1"
                    ? "及格"
                    : scope.row.states === "2"
                    ? "不及格"
                    : "满分"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="grade"
              label="考试得分"
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="time"
              label="考试时间"
              width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="pangeChange"
            :current-page.sync="nowPage"
          />
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import comheader from "../Common/comheader";
import comtop from "../Common/comtop";
// /exam/Public/testexam/
export default {
  components: {
    comheader,
    comtop,
  },
  props: {},
  data() {
    return {
      nowPage: 1,
      nowIndexButton: 0,
      examButtonList: [],
      nowCourseware: "",
      courseware: [],
      nowTestPaper: "",
      testPaper: [],
      nowPersonnel: "",
      personnel: [],
      nowDepartment: "",
      department: [],
      nowExamResult: "",
      examResult: [],
      selectTime: [],
      total: 1,
      tableData: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.getCourseList();
      this.getPaperList();
      this.getDepartList();
      this.getStateList();
      this.getPeoList();
      this.getReportList(false, 1);
    },
    changeStatistics(index) {
      this.nowIndexButton = index;
    },

    // 获取课件
    getCourseList() {
      var data = {
        service: "ShareCourse.CourseList",
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        const { data, ret, msg } = { ...res.data };
        if (ret === 200) {
          const { list, code } = { ...data };
          if (code) {
            this.$message.error("获取课件列表失败!");
            return;
          }
          const dataList = list.map((item) => {
            const { id, title } = { ...item };
            return { name: title, value: Number(id) };
          });
          this.courseware = dataList;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 获取试卷列表
    getPaperList() {
      var data = {
        service: "ShareCourse.PaperList",
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        const { data, ret, msg } = { ...res.data };
        if (ret === 200) {
          const { list, code } = { ...data };
          if (code) {
            this.$message.error("获取试卷列表失败!");
            return;
          }
          const dataList = list.map((item) => {
            const { p_id, p_name } = { ...item };
            return { name: p_name, value: Number(p_id) };
          });
          this.testPaper = dataList;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 获取人员
    getPeoList() {
      var data = {
        service: "ShareCourse.PeoList",
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        const { data, ret, msg } = { ...res.data };
        if (ret === 200) {
          const { list, code } = { ...data };
          if (code) {
            this.$message.error("获取人员列表失败!");
            return;
          }
          const dataList = list.map((item) => {
            const { user_id, nickname } = { ...item };
            return { name: nickname, value: Number(user_id) };
          });
          this.personnel = dataList;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 获取部门
    getDepartList() {
      var data = {
        service: "ShareCourse.DepartList",
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        const { data, ret, msg } = { ...res.data };
        if (ret === 200) {
          const { list, code } = { ...data };
          if (code) {
            this.$message.error("获取部门列表失败!");
            return;
          }
          const dataList = list.map((item) => {
            const { id, sec_name } = { ...item };
            return { name: sec_name, value: Number(id) };
          });
          this.department = dataList;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 获取考试结果
    getStateList() {
      var data = {
        service: "ShareCourse.StateList",
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        const { data, ret, msg } = { ...res.data };
        if (ret === 200) {
          const { list, code } = { ...data };
          if (code) {
            this.$message.error("获取考试结果列表失败!");
            return;
          }
          const dataList = list.map((item) => {
            const { id, title } = { ...item };
            return { name: title, value: Number(id) };
          });
          this.examResult = dataList;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 获取搜索结果
    getReportList(showTips = false, page) {
      var data = {
        service: "ShareCourse.ReportList",
        page,
        cwid: this.nowCourseware,
        paper_id: this.nowTestPaper,
        user_id: this.nowPersonnel,
        departid: this.nowDepartment,
        statesid: this.nowExamResult,
        start_time: this.selectTime && this.selectTime[0],
        end_time: this.selectTime && this.selectTime[1],
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        const { data, ret, msg } = { ...res.data };
        if (ret === 200) {
          const { list, code, count } = { ...data };
          if (code) {
            this.$message.error("获取搜索结果列表失败!");
            return;
          }
          showTips && this.$message.success("搜索成功!");
          this.tableData = list;
          this.total = Number(count);
          this.upTableStyle();
          if (page === 1) {
            this.nowPage = 1;
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    pangeChange(page) {
      this.getReportList(false, page);
    },
    upTableStyle() {
      // const t = setTimeout(() => {
      //   const col2 = $(".el-table_1_column_2");
      //   const col4 = $(".el-table_1_column_4");
      //   const headCol2 = $(".has-gutter .el-table_1_column_2");
      //   const headCol4 = $(".has-gutter .el-table_1_column_4");
      //   console.log(col2.length);
      //   Array(col2, col4).forEach((item) =>
      //     item.css("border", "none !important")
      //   );
      //   Array(headCol2, headCol4).forEach((item) =>
      //     item.css("padding-left", "60px")
      //   );
      //   clearTimeout(t);
      // }, 1000);
    },
    // 预览课件
    previewCourseware(aid, wid) {
      const host = location.host;
      const test = "http://test.junchenlun.com";
      const official = "https://www.junchenlun.com";
      const url = `/xt/detail?id=${aid}&wid=${wid}`;
      const addr = host === "exam.junchenlun.com" ? official + url : test + url;
      window.open(addr);
    },
    // 预览试卷
    previewPaper(id) {
      const previewPath = { path: "/previewTest/", query: { id } };
      this.$router.push(previewPath);
    },
  },
};
</script>

<style  scoped>
.flex {
  display: flex;
}
.el-main {
  padding: 0;
}
.crumbs {
  font-size: 16px;
  padding-left: 20px;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #ddd;
}
#main {
  padding: 30px 60px;
}
.result-select {
  margin: 30px 0 10px;
}
.el-select {
  margin: 0 10px;
}
.el-range-editor.el-input__inner {
  margin: 0 10px;
}
.el-select:first-child {
  margin-left: 0;
}

/* .result-table /deep/ .el-table_1_column_2,
.result-table /deep/ .el-table_1_column_4 {
  border-right: none !important;
}

.result-table /deep/ .has-gutter .el-table_1_column_2,
.result-table /deep/ .has-gutter .el-table_1_column_4 {
  padding-left: 60px;
} */

.result-table /deep/ .has-gutter th:nth-child(2),
.result-table /deep/ .has-gutter th:nth-child(4) {
  border-right: none;
  padding-left: 60px;
}
.result-table /deep/ tbody td:nth-child(2),
.result-table /deep/ tbody td:nth-child(4) {
  border-right: none;
}

.el-pagination {
  text-align: center;
  margin: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/courseware-exam/curseware-exam.vue